export default {
  install(Vue)  {
    
    Vue.prototype.setLocalStorage = function(key,value) {
      var curtime = new Date().getTime(); // 获取当前时间 ，转换成JSON字符串序列
      var valueDate = JSON.stringify({
        val: value,
        timer: curtime
      });
      localStorage.setItem(key, valueDate)
    }

    Vue.prototype.getLocalStorage = function(key){
      var exp = 60 * 60 * 24 * 1000 * 30; // 一天的秒数
      if (localStorage.getItem(key)) {
        var vals = localStorage.getItem(key); // 获取本地存储的值
        var dataObj = JSON.parse(vals); // 将字符串转换成JSON对象
        // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间
        var isTimed = new Date().getTime() - dataObj.timer > exp;
        if (isTimed) {
          localStorage.removeItem(key);
          return null;
        } else {
          var newValue = dataObj.val;
        }
        return newValue;
      } else {
        return null;
      }
    }

    Vue.prototype.millonFormat = function (n) {
      let regPos = /^\d+(\.\d+)?$/; //非负浮点数
      let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数      
      if(regPos.test(n) || regNeg.test(n)){
        let _n = n
        n = Math.abs(n)
        n = n.toString()
        var re = /\d{1,3}(?=(\d{3})+$)/g
        var n1 = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) { return s1.replace(re, "$&,") + s2; })
        if(_n>=0){
          return n1
        }else{
          return '-' + n1
        }
      }else{
        return n
      }
    }

    Vue.prototype.highlighted = function(arr, con){
      
      if(arr.length > 0 && con !== null){
        for(let i=0;i<arr.length;i++){
          /**
           * i不区分大小写
           * g查找全部内容而非第一次命中后终止
           * 正则转义
           * 正则查找
           * 添加标签
           * .号正则替换Bug
           */
          let str = arr[i].replace(/[*+?^${}()|[\]\\]/g, '\\$&')
          let reg = new RegExp(str, 'gi')
          let colorspan = "<b>" + str + "</b>"
          con = con.replace(reg, colorspan)
        }
      }
      return con
    }

    /**
     * 关键词高亮
     */
    Vue.prototype.Highlight = function(arr, con){
      let len = arr.length
      if(len > 0 && con != null){
        for(let i=0; i<len; i++){
          let str = arr[i].replace(/[*+?^${}()|[\]\\]/g, '\\$&')
          let reg = new RegExp(str, 'gi')
          let colorspan = "<b>" + str + "</b>"
          con = con.replace(reg, colorspan)
        }
      }
      return con
    }

    Vue.prototype.getTableCellStyle = function ({ column }) {
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }
      return {}
    }
    
  }
}
